import { useGetResources } from '@hooks/useGetResources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

import { trackTool } from '@helsenorge/framework-utils/adobe-analytics';

import { useAppDispatch, useAppSelector } from '../../store';
import { findAktivitetToRemoveIdSelector } from '../../store/selectors';
import { closeLightboxes } from '../../store/verktoy/slice/verktoySlice';
import { removeLaeringsaktivitetThunk } from '../../store/verktoy/thunks';
import { erVerktoyTilgjengelig } from '../../utils/utils';

const DeleteVerktoyConfirmation = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const resources = useGetResources();
  const aktivitetToRemove = useAppSelector(state => state.verktoy.aktivitetToRemove);

  const aktivitetToRemoveId = useAppSelector(findAktivitetToRemoveIdSelector);

  if (!aktivitetToRemove) {
    return null;
  }

  const onConfirm = (): void => {
    if (aktivitetToRemoveId) {
      trackTool('Verktøy', '', aktivitetToRemove.Navn, 'fjern verktøy');
      dispatch(removeLaeringsaktivitetThunk({ aktivitetsId: aktivitetToRemoveId }));
    }
  };
  const handleClose = (): void => {
    dispatch(closeLightboxes());
  };

  let confirmButtonText = resources?.deleteVerktoyButtonText;
  let headerText = resources?.confirmFjernVerktoyHeader.replace('{0}', aktivitetToRemove.Navn);
  let descriptionText: string | undefined;
  if (!erVerktoyTilgjengelig(aktivitetToRemove)) {
    headerText = resources?.confirmSlettVerktoyHeader.replace('{0}', aktivitetToRemove.Navn);
    descriptionText = resources?.confirmSlettUtgattVerktoyBody.replace('{0}', aktivitetToRemove.Navn);
  } else if (aktivitetToRemove.Laeringsressurs.KreverForskrivning) {
    descriptionText = resources?.confirmFjernVerktoyBodyForskrivning.replace('{0}', aktivitetToRemove.Navn);
  } else {
    confirmButtonText = resources?.removeVerktoyButtonText;
    headerText = resources?.confirmFjernVerktoyHeader.replace('{0}', aktivitetToRemove.Navn);
    descriptionText = resources?.confirmFjernVerktoyBody.replace('{0}', aktivitetToRemove.Navn);
  }

  return (
    <Modal
      ariaLabel="delete-verktoy-confirmation-modal"
      testId="delete-verktoy-confirmation"
      title={headerText || ''}
      description={descriptionText}
      primaryButtonText={confirmButtonText}
      secondaryButtonText={resources?.modalCancelButtonText}
      onSuccess={onConfirm}
      onClose={handleClose}
    ></Modal>
  );
};

export default DeleteVerktoyConfirmation;
